import React, { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { Layout } from "antd";
import FooterApp from "./FooterApp";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
const { Header, Content, Footer, Sider } = Layout;

const Dashboard = ({ children, title, superAdmin }) => {
  const [collapsed, setCollapsed] = useState(false);
  const storeInfo = useSelector((state) => state?.store)?.store?.storeInfo;

  return (
    <>
      <Layout
        style={{
          minHeight: "100vh",
        }}
      >
        <Sider
          style={{
            background: "white",
          }}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
        >
          <Link to="/dashboard">
            <p className="text-center text-xl font-bold py-2">
              {storeInfo?.name}
            </p>
          </Link>
          <Sidebar superAdmin={superAdmin} />
        </Sider>
        <Layout>
          <Header style={{ background: "white", padding: "0 20px" }}>
            <Navbar title={title} />
          </Header>
          <Content
            style={{
              margin: "0 16px",
              paddingTop: "20px",
            }}
          >
            {children}
          </Content>
          <Footer style={{ padding: 0 }}>
            <FooterApp />
          </Footer>
        </Layout>
      </Layout>
    </>
  );
};

export default Dashboard;
